import { Reveal } from "../components/Reveal";
import { useModal } from "../context/ModalContext";
import { Link } from "react-router-dom";
import { Car, Cog, RefreshCw, Plus, Milestone, ClipboardCheck, ArrowRight } from "lucide-react";

const SERVICES = [
  { icon: Cog, name: "Automatic Lessons", desc: "Stress-free learning with no clutch or gears — our most popular choice.", type: "Automatic", path: "/automatic-driving-lessons-northolt" },
  { icon: Car, name: "Manual Lessons", desc: "Full control and a full licence to drive any car, manual or automatic.", type: "Manual", path: "/manual-driving-lessons-northolt" },
  { icon: RefreshCw, name: "Refresher Lessons", desc: "Rebuild confidence if you've passed but haven't driven in a while.", type: "Refresher" },
  { icon: Plus, name: "Pass Plus", desc: "Sharpen your skills post-test and potentially lower your insurance.", type: "Pass Plus" },
  { icon: Milestone, name: "Motorway Lessons", desc: "Drive faster, busier roads with confidence and control.", type: "Motorway" },
  { icon: ClipboardCheck, name: "Mock Tests", desc: "Real test conditions so there are no surprises on the big day.", type: "Mock Test" },
];

export function Services() {
  const { open } = useModal();
  return (
    <section id="services" className="section-pad bg-neutral-50" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
            <div>
              <span className="overline">Our Services</span>
              <h2 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">
                Lessons for every <span className="brand-text">learner</span>
              </h2>
            </div>
            <button className="btn-outline self-start" onClick={() => open("quote")} data-testid="services-quote-btn">Get a Free Quote <ArrowRight size={16} /></button>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => (
            <Reveal key={s.name} delay={i * 0.05} className={i === 0 ? "lg:col-span-1" : ""}>
              <article className="group text-left w-full h-full card-soft p-7 hover:-translate-y-1 hover:shadow-soft-lg transition-[transform,box-shadow] duration-300 relative overflow-hidden">
                <span className="inline-flex w-12 h-12 rounded-2xl bg-neutral-900 text-white items-center justify-center mb-5 group-hover:brand-gradient transition-colors">
                  <s.icon size={22} strokeWidth={1.8} />
                </span>
                <h3 className="font-heading text-xl font-bold">{s.name}</h3>
                <p className="mt-2 text-sm text-neutral-500 leading-relaxed">{s.desc}</p>
                <div className="mt-5 flex flex-wrap items-center gap-4">
                  <button
                    onClick={() => open("booking", { lesson_type: s.type })}
                    className="inline-flex items-center gap-1 text-sm font-semibold text-brand-red"
                    data-testid={`service-${s.type.toLowerCase().replace(/ /g,"-")}`}
                  >
                    Book this <ArrowRight size={15} />
                  </button>
                  {s.path && <Link to={s.path} className="text-sm font-semibold text-neutral-700 hover:text-brand-red underline underline-offset-4">Lesson details</Link>}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
